module.exports = __webpack_public_path__ + "img/rectangle1.420dbdf9.png";